<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="68px">
      <el-form-item  prop="username">
        <el-input
          v-model="queryParams.username"
          placeholder="请输入账号"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="dataList" border>
      <el-table-column type="index" width="55" align="center" />
      <el-table-column label="账号" align="center" prop="username" />
      <el-table-column label="昵称" align="center" prop="realName" />
      <el-table-column label="代理商总数" align="center" prop="agentCount">
        <template slot-scope="scope">
          <el-link v-if="scope.row.agentCount>0" type="primary" :underline="false" @click="handleAgentSelect(scope.row)">{{ scope.row.agentCount }}</el-link>
          <span v-else>{{ scope.row.agentCount }}</span>
        </template>
      </el-table-column>
      <el-table-column label="总卡数" align="center" prop="totalCard" >
        <template slot-scope="scope">
          <el-link v-if="scope.row.totalCard>0" type="primary" :underline="false" @click="jumpCard({salesmanUserId:scope.row.userId})">{{ scope.row.totalCard }}</el-link>
          <span v-else>{{ scope.row.totalCard }}</span>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getList"
    />

    <el-dialog title="代理商列表" :visible.sync="open" width="700px" append-to-body :close-on-click-modal="false">
      <el-form :model="agentParams" ref="agentParams" :inline="true" label-width="68px">
      <el-form-item  prop="company">
        <el-input
          v-model="agentParams.company"
          placeholder="请输入公司名称"
          clearable
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="selectAgentPage">搜索</el-button>
      </el-form-item>
    </el-form>
      <el-table :data="agentList" border style="width: 95%">
        <el-table-column prop="username" label="昵称" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="company" label="公司名" align="center"  :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="jumpCard({userId:scope.row.userId})">{{ scope.row.company }}</el-link>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="agentTotal>0"
        :total="agentTotal"
        :page.sync="agentPageNum"
        :limit.sync="agentPageSize"
        @pagination="selectAgentPage"
      />
    </el-dialog>
  </div>
</template>

<script>
import { usersSalemans , agentListsData} from "@/api/api";

export default {
  name: "salemans",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 总条数
      total: 0,
      // 表格数据
      dataList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      pageNum:1,
      pageSize:10,
      agentTotal:0,
      agentPageNum:1,
      agentPageSize:10,
      agentList:[],
      // 查询参数
      queryParams: {
        username: undefined,
      },
      agentParams:{
        companyName:undefined,
        salesmanUserId:undefined
      }

    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询岗位列表 */
    getList() {
      this.loading = true;
      let params = {
        model:{
          ... this.queryParams,
        },
        page: this.pageNum,
        pageSize: this.pageSize,
      }
      usersSalemans(params).then(res => {
        this.dataList = res.data.data.records;
        this.total = res.data.data.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    jumpCard(params){
      this.open = false
      this.$router.push({name:'cards',params:params});
    },
    handleAgentSelect(row){
      this.agentParams.salesmanUserId = row.userId
      this.open = true
      this.selectAgentPage()
    },
    selectAgentPage(){
      let params = {
        model: {
        ...this.agentParams
        },
        page: this.agentPageNum,
        pageSize: this.agentPageSize,
      };
      agentListsData(params).then(res => {
        this.agentList = res.data.data.records;
        this.agentTotal = res.data.data.total;
          
      });
    }
    
  }
};
</script>
